const trackingUtils = require('od-modules/utils/tracking.utils');

const UNIQUE_VISIT_WITH_SEARCH_KEY = 'of2UniqueVisitWithSearchKey';

const isMobile = Odigeo.SessionScope.flow === 'mobile';
const isDesktop = Odigeo.SessionScope.flow === 'desktop';

const dispatchInfo = (error) => Odigeo.trigger('frontend-shell:info', error);
const dispatchWarning = (error) => Odigeo.trigger('frontend-shell:warning', error);

const isEnabled = () => {
    return Odigeo.AB.isFrontendShellEnabled && !Odigeo.Utils.isRequestApp('dp');
};

const isInControlScope = () => {
    const isABScope = !Odigeo.SessionScope.marketingPortalIsMeta && !Odigeo.Utils.isRequestApp('dp');
    const isMobileControlScope = isMobile && !Odigeo.AB.isFrontendMobileActive;
    const isDesktopControlScope = isDesktop && !Odigeo.AB.isFrontendDesktopActive;
    return isABScope && (isMobileControlScope || isDesktopControlScope);
};

const OF2_TEST_BOUNCING_KEY = 'of2TestBouncing';
const logABBouncing = () => {
    let testBouncing = Odigeo.Storage.get(OF2_TEST_BOUNCING_KEY) || '';
    let test;
    if (isEnabled()) {
        test = 'B';
    } else if (isInControlScope()) {
        test = 'A';
    } else {
        test = 'X';
    }
    if (test && testBouncing[testBouncing.length - 1] !== test) {
        testBouncing += test;
        Odigeo.Storage.set(OF2_TEST_BOUNCING_KEY, testBouncing);
        if (testBouncing.length > 1) {
            dispatchWarning(new Error(`Bouncing between ABs. Sequence: ${testBouncing}`));
        }
    }
};

const logShellEnabledButMapiCallMode = (mode) => {
    if (isEnabled() && mode !== '') {
        dispatchInfo(new Error(`OF2 enabled but mode is: ${mode}`));
    }
};

const flightResults = {
    trackCounterMetric(metricName) {
        const visitId = Odigeo.SessionScope.visitId;
        const uniqueVisitWithSearchId = Odigeo.Storage.get(UNIQUE_VISIT_WITH_SEARCH_KEY) || '';
        if (uniqueVisitWithSearchId !== visitId) {
            Odigeo.Storage.set(UNIQUE_VISIT_WITH_SEARCH_KEY, Odigeo.SessionScope.visitId);
            trackingUtils.counterMetric(metricName);
        }
    },
    logABBouncing,
    logShellEnabledButMapiCallMode,
    isEnabled,
    isInControlScope,
};

module.exports = flightResults;
